import axios from 'axios';

let url = '';

export const initRepositoryService = (config: Record<string, any>) => {
    url = config.repositoryUrl;
};

export const getLatestRepository = async () => {
    const res = await axios.get<RepositoryData>(`${url}/repositories/latest`);
    return res.data;
};

export const getLatestRepositoryConfig = async () => {
    const res = await axios.get<RepositoryConfigData>(`${url}/repositories/latest/config`);
    return res.data;
};
